import SelectRadioInputSheet from '../../common/sheets/SelectRadioInputSheet';
import { IncomeType } from '../types/Income';
import { formatIncomeType } from '../utils/incomeUtils';

interface IncomeTypeSelectionSheetProps {
    isOpen: boolean;
    selectedOption: IncomeType;
    onSelectOption: (incomeType: IncomeType | null) => void;
    onClose: () => void;
}

const IncomeTypeSelectionSheet = ({
    isOpen,
    selectedOption,
    onSelectOption,
    onClose,
}: IncomeTypeSelectionSheetProps) => {
    return (
        <SelectRadioInputSheet
            title="Type of income"
            options={IncomeType}
            selectedOption={selectedOption}
            onSelectOption={onSelectOption}
            isOpen={isOpen}
            onClose={onClose}
            toLabelFn={formatIncomeType}
        />
    );
};

export default IncomeTypeSelectionSheet;
